<template>
  <div>
    <!-- ══ DESKTOP HEADER ══ -->
    <div class="header hidden-sm-and-down" :class="{ scrolled: isScrolled }">
      <div class="header-inner">

        <!-- Logo -->
        <router-link to="/" class="logo-link">
          <v-img
            contain
            src="../assets/Images/logo.png"
            height="42px"
            max-width="140px"
          ></v-img>
        </router-link>

        <!-- Nav Links -->
        <nav class="nav-links">
          <router-link to="/" class="nav-item" exact>
            <span class="nav-label">Home</span>
            <span class="nav-underline"></span>
          </router-link>

          <a
            class="nav-item"
            v-scroll-to="{ el: '#our-aboutus', duration: 500, easing: 'ease-in' }"
            @click="$router.push('/')"
          >
            <span class="nav-label">About Us</span>
            <span class="nav-underline"></span>
          </a>

          <router-link to="/coursesPage" class="nav-item">
            <span class="nav-label">Specialized</span>
            <span class="nav-underline"></span>
          </router-link>

          <router-link to="/contactUs" class="nav-item contact-btn">
            <span>Contact Us</span>
          </router-link>
        </nav>

      </div>
    </div>

    <!-- ══ MOBILE HEADER ══ -->
    <div class="mob-header hidden-md-and-up" :class="{ scrolled: isScrolled }">
      <div class="mob-inner">
        <router-link to="/" class="logo-link">
          <v-img contain src="../assets/Images/logo.png" height="36px" max-width="110px"></v-img>
        </router-link>
        <button class="mob-menu-btn" @click="drawer = !drawer" :class="{ open: drawer }">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>

    <!-- ══ MOBILE DRAWER ══ -->
    <transition name="drawer-slide">
      <div class="mob-drawer hidden-md-and-up" v-if="drawer">
        <router-link to="/" class="mob-nav-item" @click.native="drawer = false" exact>Home</router-link>
        <a
          class="mob-nav-item"
          v-scroll-to="{ el: '#our-aboutus', duration: 500, easing: 'ease-in' }"
          @click="drawer = false; $router.push('/')"
        >About Us</a>
        <router-link to="/coursesPage" class="mob-nav-item" @click.native="drawer = false">Specialized</router-link>
        <router-link to="/contactUs" class="mob-nav-item" @click.native="drawer = false">Contact Us</router-link>
      </div>
    </transition>

    <!-- Backdrop -->
    <transition name="fade">
      <div class="mob-backdrop hidden-md-and-up" v-if="drawer" @click="drawer = false"></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      drawer: false,
      isScrolled: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.isScrolled = window.scrollY > 20
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Jost:wght@300;400;500;600&display=swap');

/* ══ BASE ══ */
* { box-sizing: border-box; margin: 0; padding: 0; }

/* ══ DESKTOP HEADER ══ */
.header {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 999;
  height: 72px;
  background: rgba(255, 255, 255, 0.0);
  backdrop-filter: blur(0px);
  border-bottom: 1px solid transparent;
  transition: background 0.35s ease, backdrop-filter 0.35s ease, border-color 0.35s ease, box-shadow 0.35s ease;
}

/* Scrolled state — white with soft shadow */
.header.scrolled {
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 2px 24px rgba(0, 0, 0, 0.06);
}

.header-inner {
  max-width: 1280px;
  margin: 0 auto;
  height: 100%;
  padding: 0 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Logo */
.logo-link {
  text-decoration: none;
  display: flex;
  align-items: center;
}

/* Nav */
.nav-links {
  display: flex;
  align-items: center;
  gap: 40px;
}

.nav-item {
  position: relative;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.nav-label {
  font-family: 'Jost', sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.55);
  transition: color 0.2s;
}

/* Underline bar */
.nav-underline {
  display: block;
  height: 1.5px;
  width: 0;
  background: #caa271;
  transition: width 0.28s ease;
  border-radius: 2px;
}

.nav-item:hover .nav-label,
.nav-item.router-link-exact-active .nav-label,
.nav-item.router-link-active .nav-label {
  color: #0a0a0a;
}

.nav-item:hover .nav-underline,
.nav-item.router-link-exact-active .nav-underline,
.nav-item.router-link-active .nav-underline {
  width: 100%;
}

/* Contact button — distinct CTA */
.contact-btn {
  background: #0a0a0a;
  padding: 10px 26px;
  border-radius: 2px;
  flex-direction: row;
  gap: 0;
}
.contact-btn span {
  font-family: 'Jost', sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: #fff;
  transition: color 0.2s;
}
.contact-btn:hover {
  background: #caa271;
}
.contact-btn:hover span { color: #fff; }

/* ══ MOBILE HEADER ══ */
.mob-header {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 999;
  height: 64px;
  background: rgba(255,255,255,0.0);
  border-bottom: 1px solid transparent;
  transition: background 0.35s, border-color 0.35s, box-shadow 0.35s;
}
.mob-header.scrolled {
  background: rgba(255,255,255,0.97);
  border-bottom: 1px solid rgba(0,0,0,0.06);
  box-shadow: 0 2px 16px rgba(0,0,0,0.06);
}

.mob-inner {
  height: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Hamburger */
.mob-menu-btn {
  display: flex;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}
.mob-menu-btn span {
  display: block;
  height: 1.5px;
  background: #0a0a0a;
  border-radius: 2px;
  transition: width 0.25s, transform 0.3s, opacity 0.3s;
}
.mob-menu-btn span:nth-child(1) { width: 22px; }
.mob-menu-btn span:nth-child(2) { width: 16px; }
.mob-menu-btn span:nth-child(3) { width: 22px; }

.mob-menu-btn.open span:nth-child(1) { transform: translateY(6.5px) rotate(45deg); width: 22px; }
.mob-menu-btn.open span:nth-child(2) { opacity: 0; }
.mob-menu-btn.open span:nth-child(3) { transform: translateY(-6.5px) rotate(-45deg); width: 22px; }

/* ══ MOBILE DRAWER ══ */
.mob-drawer {
  position: fixed;
  top: 64px; right: 0;
  width: 260px;
  height: calc(100vh - 64px);
  z-index: 998;
  background: #fff;
  border-left: 1px solid rgba(0,0,0,0.06);
  display: flex;
  flex-direction: column;
  padding: 32px 28px;
  gap: 8px;
  box-shadow: -8px 0 32px rgba(0,0,0,0.08);
}

.mob-nav-item {
  font-family: 'Jost', sans-serif;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: rgba(0,0,0,0.55);
  text-decoration: none;
  padding: 14px 0;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  transition: color 0.2s;
  cursor: pointer;
}
.mob-nav-item:hover,
.mob-nav-item.router-link-exact-active,
.mob-nav-item.router-link-active {
  color: #caa271;
}

/* Backdrop */
.mob-backdrop {
  position: fixed;
  inset: 0;
  z-index: 997;
  background: rgba(0,0,0,0.25);
}

/* ══ TRANSITIONS ══ */
.drawer-slide-enter-active,
.drawer-slide-leave-active {
  transition: transform 0.32s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.32s ease;
}
.drawer-slide-enter,
.drawer-slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>